module.exports = __webpack_public_path__ + "static/img/lab-m-sponsor.9188eb1d.png";